import Vue from 'vue'
import Vuex from 'vuex'

import appSettings from '@/settings'
import i18n from './storeI18n'

import appState from './storeAppState'
import commonData from './storeCommonData'

import activeUser from './storeActiveUser'
import permissions from './storePermissions'

import mainMenu from './storeMainMenu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    appSettings,
    i18n,
    appState,
    activeUser,
    permissions,
    mainMenu,
    commonData
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js